<form class="flex flex-col justify-start items-stretch" [formGroup]="attributeForm">
    <div class="flex flex-row items-end gap-2">
        <div class="w-1/5">
            <div class="form-control w-full">
                <label class="label pb-0">
                    <span class="label-text" i18n>Attribute name</span>
                </label>
                <input type="text" class="input input-bordered w-full" formControlName="attributeName" />
            </div>
        </div>
        <div class="w-1/5">
            <div class="form-control w-full">
                <label class="label pb-0">
                    <span class="label-text" i18n>Value type</span>
                </label>
                <select class="w-full select select-bordered" formControlName="attributeValueType">
                    <option *ngFor="let type of attributeValueTypes" [value]="type">
                        {{ getValueTypeDescription(type) }}
                    </option>
                </select>
            </div>
        </div>
        <div class="flex-1">
            <div class="form-control w-full">
                <label class="label pb-0">
                    <span class="label-text" i18n>Attribute value(s</span>
                </label>
                <input type="text" class="input input-bordered w-full" formControlName="attributeValue" />
            </div>
        </div>
        <div class="flex-1" *ngIf="attributeForm.get('attributeValueType').value === 'STRING'">
            <div class="form-control w-full">
                <label class="label pb-0">
                    <span class="label-text" i18n>Language</span>
                </label>
                <input type="text" class="input input-bordered w-full" formControlName="attributeLocale" />
            </div>
        </div>

        <button *ngIf="!disabled && deletable" class="btn btn-error" (click)="delete.emit()">
            <iota-icon icon="trash"></iota-icon>
        </button>
    </div>
    <div class="flex flex-row gap-2">
        <div class="w-1/5">
            <span class="text-error" *ngIf="attributeForm.get('attributeName').invalid" i18n>Attribute name is mandatory</span>
        </div>
        <div class="w-1/5">
            <span class="text-error" *ngIf="attributeForm.get('attributeValueType').invalid" i18n>Value type is mandatory</span>
        </div>
        <div class="flex-1">
            <span class="text-error" *ngIf="attributeForm.get('attributeValue').hasError('required')" i18n>The value cannot be empty </span>
            <span class="text-error" *ngIf="attributeForm.get('attributeValue').hasError('parsingFailed')" i18n
                >Unable to parse the values</span
            >
        </div>
    </div>
</form>
